import { render, staticRenderFns } from "./PortraitPage.vue?vue&type=template&id=774f700b&scoped=true"
var script = {}
import style0 from "./PortraitPage.vue?vue&type=style&index=0&id=774f700b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f700b",
  null
  
)

export default component.exports